// Application-wide constants

// API endpoints
export const API_BASE_URL =
	process.env.REACT_APP_API_URL || "https://al-amel-api.onrender.com/api";
// process.env.REACT_APP_API_URL || "http://localhost:5155/api";
export const LOCAL_API_URL = "http://localhost:5155/api";

// Class periods
export const CLASS_PERIODS = [
	{ value: "1", label: "1st Period" },
	{ value: "2", label: "2nd Period" },
	{ value: "3", label: "3rd Period" },
	{ value: "4", label: "4th Period" },
	{ value: "5", label: "5th Period" },
	{ value: "6", label: "6th Period" },
	{ value: "7", label: "7th Period" },
];

// Storage keys
export const STORAGE_KEYS = {
	USER: "user",
	CLASS_LOGS: "classLogs",
	LANGUAGE: "language",
	TOKEN_EXPIRATION: "tokenExpiration",
};

// Default language
export const DEFAULT_LANGUAGE = "en";

// Supported languages
export const SUPPORTED_LANGUAGES = ["en", "ar"];

// RTL languages
export const RTL_LANGUAGES = ["ar", "he", "fa", "ur"];
